import { useMemo } from "react";
import { STANDARD_COLORS } from "../app/globalConstants";
import McDropdownNew from "./McDropdown/MCDropdownNew";

type ColorOption = {
  value: string;
  label: string;
  color: string;
};

export const ColorDropdown = ({
  activeColor,
  setColor,
}: {
  activeColor?: string | null;
  setColor: (color: string) => void;
}) => {
  const options = useMemo<ColorOption[]>(
    () =>
      Object.entries(STANDARD_COLORS).map(([value, color]) => ({
        value,
        color,
        label: value.toUpperCase(),
      })),
    [],
  );

  const selected = options.find((option) => option.value === activeColor) ?? null;

  return (
    <McDropdownNew
      currentValue={selected as any}
      onChange={(_, newValue) => setColor(newValue.value)}
      options={options}
      displayKey="label"
      type="colordot"
      defaultTitle="Velg farge"
    />
  );
};
